Greenmile.MassiveSmartGeocode = Greenmile.MassiveSmartGeocode || {};

Greenmile.MassiveSmartGeocode.ProgressBar = function (selector, notify) {

    this.modalForm = null;

    const popupScope = selector + ' .popupFormContainer';
    const contentPopup = function () {
        const popup = document.querySelector(popupScope);

        if (popup !== null) {
            const isProcessing = notify === 'processingRouter' || notify === 'processingForm';
            const headerTitle = isProcessing
                ? Monet.I18n.getResourcesByKey("ProgressPopup.headerTitle.anotherProcessSubtitle")
                : Monet.I18n.getResourcesByKey("ProgressPopup.headerTitle")
        
            const headerSubtitle = isProcessing
                ? `<span class="anotherProcessSubtitle">${Monet.I18n.getResourcesByKey("ProgressPopup.headerSubtitle.anotherProcessSubtitle")}</span>`
                : Monet.I18n.getResourcesByKey("ProgressPopup.headerSubtitle")
        
            popup.innerHTML = `
                <div class="popupHeader">
                    <div class="headerTitle">${headerTitle}</div>
                    <div class="headerSubtitle">${headerSubtitle}</div>
                </div>
                <div class="progress">
                    <div class="progressLoading"></div>
                </div>
            `;
        }
        
        $(`${selector} .closeModalWindow`).toggle(notify === 'processingForm');
    };

    this.showPopup = function () {
        const scopeBlock = selector + " #form_and_grid";
        const options = {
            width: 600,
            height: 170
        };
        const callbacks = {
            onAfterShowModalForm: contentPopup
        };

        this.modalForm = new Monet.Form.Modal(selector, options, callbacks, scopeBlock);
        this.modalForm.showModalForm();
    };

    this.isRendered = function () {
        const progressLoading = document.querySelector(selector + " .progressLoading");
        return progressLoading ? true : false;
    };

    this.update = function (dataWidth, initial) {
        try {
            const progressLoading = document.querySelector(selector + " .progressLoading");

            if (progressLoading !== null) {
                progressLoading.style.transitionDuration = initial ? 0 : (dataWidth == 1 ? '.5s' : '5s');
                progressLoading.style.width = (dataWidth * 100) + "%";
            }
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on update progress");
            error.console();
        }      
    };

    this.destroy = function () {
        try {
            const modalForm = new Monet.Form.Modal(selector);
            modalForm.closeModalWindow();
        } catch (e) {
            const error = new Monet.Exception.ReturnError(this, "Error on destroy progress");
            error.console();
        }
    };

    this.showPopupAndUpdate = function (dataWidth) {
        this.showPopup();
        this.update(dataWidth, true);
    };

};
